
@if(true){
<form [formGroup]="form" class="modal-body col-sm-12 form-group" (ngSubmit)="submitForm()">

    <div class="card">
        <div class="card-body">
            <div class="row my-2">
  @for (input of formData; track input.controlName) {
        
              @switch (input.controlType) {
        
                @case ('Hidden') {
                    <div class="col-12 col-md-6">
                        <input
                          type="hidden"
                          class="form-control"
                          [formControlName]="input.controlName"
                          [value]="input.selectedValue" />
                    </div>
                }
        
                @case ('TXT') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
                    <input
                      type="text"
                      class="form-control"
                      [formControlName]="input.controlName"
                      [placeholder]="input.placeholder || ''" />
                  </div>
                }
        
                @case ('NTXT') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
                    <input
                      type="number"
                      class="form-control"
                      [formControlName]="input.controlName"
                      [placeholder]="input.placeholder || ''" />
                  </div>
                }
        
                @case ('MTXT') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
                    <textarea
                      class="form-control"
                      [formControlName]="input.controlName"
                      rows="3"></textarea>
                  </div>
                }
        
                @case ('SHLP') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
                    <ng-select
                      [items]="input.Options"
                      bindLabel="optionName"
                      bindValue="value"
                      [clearable]="false"
                      [multiple]="false"
                      formControlName="{{ input.controlName }}">
                    </ng-select>
                  </div>
                }
        
                @case ('MHLP') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
                    <ng-select
                      [items]="input.Options"
                      bindLabel="optionName"
                      bindValue="value"
                      [multiple]="true"
                      [clearable]="false"
                      formControlName="{{ input.controlName }}">
                    </ng-select>
                  </div>
                }
        
                @case ('TXTNTXT') {
                  <div class="col-12 col-md-6">
                    <label class="form-label">{{ input.captionName }}</label>
        
                    <div class="row">
                      <div class="col-6">
                        <input
                          type="text"
                          class="form-control"
                          [formControlName]="input.controlName" />
                      </div>
        
                      <div class="col-6">
                        <input
                          type="number"
                          class="form-control"
                          [formControlName]="input.controlName2" />
                      </div>
                    </div>
                  </div>
                }
        
              } <!-- END SWITCH -->
        
              <!-- END ROW -->
            }
        </div> 
    </div>
</div>

  <!-- ---------- SUBMIT & APPROVE/REJECT BUTTONS ---------- -->
  <div class="row mt-4">

    @if (IsDisplayButton == '0') {
      <div class="col-12 text-center">
        <button class="btn btn-primary px-5" type="submit">{{ buttonName }}</button>
      </div>
    }

    @else {
      <div class="col-12 d-flex justify-content-center gap-3">
        <button class="btn btn-primary px-4" type="submit">{{ buttonName }}</button>
        <button class="btn btn-success px-4" type="button" (click)="Approve()">Approve</button>
        <button class="btn btn-danger px-4" type="button" (click)="Reject()">Reject</button>
      </div>
    }

  </div>

</form>

}@else {
    <!-- <form [formGroup]="form" class="modal-body  col-sm-12 form-group" (submit)="submitForm(); ">
        <ng-template ngFor let-input [ngForOf]="formData">
            <ng-container [ngSwitch]="input.controlType">
                <ng-template [ngSwitchCase]="'Hidden'">
                    <div style="display:none; ">
    
                        <input class="form-control" [formControlName]="input.controlName" type="hidden" [value]="input.selectedValue" />
    
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'TXT'">
                    <br>
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <input class="col-sm-6 form-control" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" />
                        <div class="col-sm-2">&nbsp;</div>
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'NTXT'">
                    <br>
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <input class="col-sm-6 form-control" [formControlName]="input.controlName" type="number" [value]="input.selectedValue" [name]="input.controlName" />
                        <div class="col-sm-2">&nbsp;</div>
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'MTXT'">
                    <br>
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <textarea class="col-sm-6 form-control" [formControlName]="input.controlName" [value]="input.selectedValue" [name]="input.controlName"></textarea>
                        <div class="col-sm-2">&nbsp;</div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'SHLP'">
                    <br>
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <div class="col-sm-6 form-group">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="false" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-sm-2">&nbsp;</div>
                    </div>
                </ng-template>
    
                <ng-template [ngSwitchCase]="'MHLP'">
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4" [for]="input.controlName"> {{input.captionName}}</label>
                        <div class="col-sm-6 fullwidth">
                            <ng-select [items]="input.Options" [clearable]="false" [multiple]="true" [formControlName]="input.controlName" bindLabel="optionName" [selectableGroup]="true" [closeOnSelect]="true" bindValue="value" [(ngModel)]="input.selectedValue3">
                                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                    {{item.optionName}}
                                </ng-template>
                            </ng-select>
                        </div>
                        <div class="col-sm-2">&nbsp;</div>
                        <br><br><br>
                    </div>
                </ng-template>
                <ng-template [ngSwitchCase]="'TXTNTXT'">
                    <div class="form-group col-sm-12">
                        <label class="col-sm-4"> {{input.captionName}}</label>
                        <input class="col-sm-3 form-control" [formControlName]="input.controlName" type="text" [value]="input.selectedValue" [name]="input.controlName" />
                        <input class="col-sm-3 form-control" [formControlName]="input.controlName2" type="number" [value]="input.selectedValue3" [name]="input.controlName2" />
                        <div class="col-sm-2">&nbsp;</div>
                    </div>
    
                </ng-template>
            </ng-container>
        </ng-template>
        <div><br><br>
            <div class="col-sm-12">&nbsp;</div>
            <div class="form-group">
                <div *ngIf="this.IsDisplayButton=='0'">
                    <div class="col-sm-5">&nbsp;</div>
                    <input class="btn btn-primary col-sm-2" type="submit" value={{this.buttonName}}>
                    <div class="col-sm-5"></div>
                </div>
                <div *ngIf="this.IsDisplayButton=='1'">
                    <div class="col-sm-2">&nbsp;</div>
                    <input class="btn btn-primary col-sm-2" type="submit" value={{this.buttonName}}>
                    <div class="col-sm-1">&nbsp;</div>
                    <button type="button" class="btn btn-primary col-sm-2" (click)="Approve(); ">Approve</button>
    
                    <div class="col-sm-1">&nbsp;</div>
                    <button type="button" class="btn btn-primary col-sm-2" (click)="Reject(); ">Reject</button>
                    <div class="col-sm-2">&nbsp;</div>
                </div>
            </div>
        </div>
    </form> -->
}